import { createFileRoute } from '@tanstack/react-router';
import { DocPage } from '@/components/docs/DocPage';
import { authDocTitle, authDocDescription, authDocSections } from '@/content/docs/auth';

export const Route = createFileRoute('/_admin/docs/auth')({
  component: DocsAuthPage,
});

function DocsAuthPage() {
  return (
    <DocPage
      title={authDocTitle}
      description={authDocDescription}
      sections={authDocSections}
    />
  );
}
